module.exports = __webpack_public_path__ + "img/rating-page-text-mobile.0a01d7af.svg";